import AragLogoPng from '../images/arag_logo.png';
import styles from './styles';
import { ImageSource } from '@/components/common/display/imageSource/ImageSource';
import { default as Msg } from '@/i18n/components/FormattedMessage';
import { useIntl } from '@/i18n/hooks/useIntl';

export const AragAddressDetails = () => {
  const { t } = useIntl();

  return (
    <div className={`${styles.aragContainer} padding-bottom-l`}>
      <div className='padding-right-m'>
        <ImageSource
          image={AragLogoPng}
          imageWebp={AragLogoPng}
          imageAlt={t({
            id: `common.aragModal.aragDetails.image`,
            defaultMessage: 'arag logo',
          })}
        />
      </div>
      <ul>
        <li style={styles.aragCompanyName}>
          <Msg id={`common.aragModal.aragDetails.companyName`} defaultMessage='ARAG SE' />
        </li>
        <li>
          <Msg id={`common.aragModal.aragDetails.addressLine1`} defaultMessage='ARAG-Platz 1' />
        </li>
        <li>
          <Msg id={`common.aragModal.aragDetails.addressLine2`} defaultMessage='40472 Düsseldorf' />
        </li>
      </ul>
    </div>
  );
};
